exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".milestone-list[data-v-34c5c816] {\n  list-style-type: none;\n  padding-left: 0;\n  padding-top: 25px;\n}\n.milestone-title[data-v-34c5c816] {\n  padding-bottom: 20px;\n}\n", ""]);

// exports
